import { Pipe, PipeTransform } from "@angular/core"

export interface AnnouncementPart { text: string; url?: string }

export function announcementParts(content: string): AnnouncementPart[] {
  const parts: AnnouncementPart[] = []
  const pattern = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)|https?:\/\/[^\s<>]+/gi
  let offset = 0
  for (const match of content.matchAll(pattern)) {
    const index = match.index!
    if (index > offset) parts.push({ text: content.slice(offset, index) })
    const raw = match[2] || match[0].replace(/[.,;:!?\])]+$/, "")
    try {
      const url = new URL(raw)
      if (!["http:", "https:"].includes(url.protocol)) throw new Error("Unsupported URL")
      parts.push({ text: match[1] || raw, url: url.href })
      if (!match[2] && raw.length < match[0].length) parts.push({ text: match[0].slice(raw.length) })
    } catch {
      parts.push({ text: match[0] })
    }
    offset = index + match[0].length
  }
  if (offset < content.length) parts.push({ text: content.slice(offset) })
  return parts
}

function escapeHTML(value: string): string {
  return value.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;")
}

/** Angular sanitizes the result at the innerHTML binding; never bypass it. */
export function announcementHTML(content: string): string {
  if (/<(?:div\s+data-lens-format="rich-text"|p(?:\s|>)|h[23](?:\s|>)|ul(?:\s|>)|ol(?:\s|>))/i.test(content)) return content
  return announcementParts(content).map(part => part.url
    ? `<a href="${escapeHTML(part.url)}" target="_blank" rel="noopener noreferrer">${escapeHTML(part.text)}</a>`
    : escapeHTML(part.text)).join("")
}

@Pipe({ name: "announcementContent", standalone: true })
export class AnnouncementContentPipe implements PipeTransform {
  transform(content: string | null | undefined): string {
    return announcementHTML(content ?? "")
  }
}
